<template>
    <div
        class="l-ss-c-radio-btn"
        :class="{ 'l-ss-c-radio-btn-checked': isActive }">
        <label>
            <input
                type="radio"
                :value="label"
                :checked="isActive"
                @change="onChange">
            <span>
                <slot></slot>
            </span>
        </label>
    </div>
</template>

<script>
    import { computed } from '@/lib/vue-composition-api.js';

    export default {
        model: {
            event: 'change',
        },
        props: {
            value: {
                default: '',
            },
            label: {
                type: String,
            },
        },
        setup(props, { emit }) {
            const isActive = computed(() => {
                if (props.value && typeof props.value === 'object') {
                    return props.value.label === props.label;
                }

                return props.value === props.label;
            });

            const onChange = (event) => {
                emit('change', { event, label: event.target.value });
            };

            return {
                isActive,
                onChange,
            };
        },
    };
</script>

<style scoped>

</style>